import cloneDeep from 'lodash/cloneDeep';
import filter from 'lodash/filter';
import forEach from 'lodash/forEach';
import includes from 'lodash/includes';
import map from 'lodash/map';
import startsWith from 'lodash/startsWith';
import queryString from 'query-string';
import messages from '../components/class-courses/messages';
import { sort } from '../helpers/grid-util';

export function getAppConfig() {
    // eslint-disable-next-line no-underscore-dangle
    return window._env_ || window.pppAppConfig || undefined;
}

export function handleDefaults(defaultObj, dynamicObj) {
    for (const key in dynamicObj) {
        defaultObj[key] = dynamicObj[key];
    }
    return defaultObj;
}

export function getAlphaNumericCharacters() {
    return 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
}

export function getClassroomList(classroomsInfo) {
    const classrooms = classroomsInfo.map(item => ({ key: item.classroomId, value: item.name }));
    return classrooms;
}

export function invalidCharaters() {
    return '^[^!@#$%^&+={}/?<>]+$';
}

export function invalidEmailCharaters() {
    return '^[^()<>,;:\\/"{}]+$';
}

export function isValidEmail(emailAddress) {
    const re = /[A-Z0-9._%+-]+@[A-Z0-9.-]+.[A-Z]{2,4}/igm;
    return re.test(emailAddress);
}

export function validatePassword() {
    return '^(?=.*?[0-9])(?=.*?[A-z])[A-z0-9!@#$%&*]+$';
}

export function truncateCharacters(type, val) {
    let length;
    switch (type) {
    case 'teacher':
    case 'studentClassroom':
        length = 20;
        break;

    case 'group':
    case 'teacherClassroom':
    case 'course':
        length = 40;
        break;

    case 'assignTeacherToClassroom': length = 65;
        break;

    case 'teacherFirstName': length = 10;
        break;

    default:
        length = 20;
    }

    return val.length > length ? `${val.substring(0, length)}...` : val;
}

export function updateYearGroups(currentOptions, yearGroups) {
    const countryYearGroups = yearGroups.map(item => ({
        key: item.yearGroupEnum.toString(),
        value: item.shortName,
        selected: false
    }));
    const updatedYearGroups = currentOptions.yearGroups.concat(countryYearGroups);
    return { ...currentOptions, yearGroups: updatedYearGroups };
}

export function updateTeachers(currentOptions, allTeachers) {
    const teachers = [];
    const currentlySelectedItem = currentOptions.teachers.find(item => item.selected === true);
    teachers.push(currentOptions.teachers[0]);
    forEach(allTeachers, (item) => {
        const lastName = truncateCharacters('teacher', item.lastName);
        const firstName = truncateCharacters('teacherFirstName', item.firstName);
        let selected = false;
        if (currentlySelectedItem.data !== undefined && currentlySelectedItem.data.userProfileId === item.userProfileId) {
            selected = true;
        }
        teachers.push({ key: item.userProfileId.toString(), value: `${lastName}, ${firstName}`, selected, data: item });
    });

    return { ...currentOptions, teachers };
}

export function updateClassroomList(currentOptions, allClassrooms) {
    let classes = [];
    const currentlySelectedItem = currentOptions.classrooms.find(item => item.selected === true);
    classes = currentOptions.classrooms.filter(classroom => classroom.classroomId === undefined);
    forEach(allClassrooms, (item) => {
        let selected = false;
        if (currentlySelectedItem !== undefined && currentlySelectedItem.classroomId === item.classroomId) {
            selected = true;
        }
        classes.push({ key: item.name, value: item.name, classroomId: item.classroomId, selected });
    });

    return { ...currentOptions, classrooms: classes };
}

export function filterProductCountries(productCountries) {
    const updatedProductCountries = productCountries.map(item => ({
        key: item.code,
        value: item.name,
        selected: false,
        data: item
    }));

    return updatedProductCountries;
}

export function filterProductTeachers(productTeachers) {
    const clonedTeachers = sort({ ...productTeachers }, 'lastName', 'asc');
    const updatedProductTeachers = clonedTeachers.map(item => ({
        key: item.userProfileId,
        value: `${item.displayTitle} ${item.firstName} ${item.lastName}`,
        selected: false,
        data: item
    }));

    return updatedProductTeachers;
}

export function filterProductCourses(productCourses) {
    const updatedProductTeachers = productCourses.map(item => ({
        key: String(item.id),
        value: item.name,
        selected: false,
        data: item
    }));

    return updatedProductTeachers;
}

const searchUnassignedClasses = (unassignedClassrooms, selectedYearGroup) => {
    let filteredClassrooms = filter(unassignedClassrooms, (classroom) => {
        if (Number(classroom.yearGroup) === Number(selectedYearGroup) || Number(selectedYearGroup) === -1) {
            return true;
        }
        return false;
    });
    filteredClassrooms = filteredClassrooms.filter(Boolean);
    if (filteredClassrooms.length > 0) {
        return true;
    }
    return false;
};


export const generateStudentTeacherAssignList = (assignedList, unassignedList, selectedYearGroup, type, listObject) => {
    let additionalInfo = [];
    let elementId = null;
    let name = null;
    let yearStyle = null;
    let isUnAssignedListEmpty = false;
    let assignData = [];
    let unassignData = [];

    if (type === 'student') {
        isUnAssignedListEmpty = unassignedList.length > 0;
    } else {
        isUnAssignedListEmpty = !!((unassignedList.length > 0 &&
            searchUnassignedClasses(unassignedList, selectedYearGroup)));
    }

    if (isUnAssignedListEmpty) {
        let filteredClassroomsByYearGroup = [];
        if (type === 'student') {
            if (Number(selectedYearGroup) === -1) {
                filteredClassroomsByYearGroup = unassignedList;
            } else {
                filteredClassroomsByYearGroup = unassignedList
                    .filter(val => val.yearGroup === parseInt(selectedYearGroup, 10));
            }
        } else if (Number(selectedYearGroup) === -1) {
            filteredClassroomsByYearGroup = unassignedList;
        } else {
            filteredClassroomsByYearGroup = unassignedList
                .filter(val => val.yearGroup === Number(selectedYearGroup));
        }

        unassignData = filteredClassroomsByYearGroup.map((classroom) => {
            yearStyle = `yg${classroom.yearGroup.toString()}`;
            elementId = `class-${classroom.id}-assign`;
            name = type === 'teacher' ?
                truncateCharacters('teacherClassroom', classroom.name) :
                truncateCharacters('studentClassroom', classroom.name);
            if (type === 'student') {
                additionalInfo = classroom.assignedTeachersName;
            }

            return ({
                ...listObject,
                listItemId: classroom.id,
                elementId,
                groups: classroom.groups,
                name,
                info: {
                    additionalInfo,
                    badgeContent: classroom.yearGroupName,
                    badgeStyle: yearStyle
                },
                child: {
                    data: classroom.groups,
                    isMultiSelect: true
                },
                isExpandable: type === 'student'
            });
        });
    }

    if (assignedList.length > 0) {
        const clonedAssignedClassrooms = cloneDeep(assignedList);
        assignData = clonedAssignedClassrooms.map((classroom) => {
            yearStyle = `yg${classroom.yearGroup.toString()}`;
            elementId = `class-${classroom.id}-unassign`;
            name = type === 'teacher' ?
                truncateCharacters('teacherClassroom', classroom.name) :
                truncateCharacters('studentClassroom', classroom.name);
            if (type === 'student') {
                additionalInfo = classroom.assignedTeachersName;
            }
            const assignedGroup = classroom.groups.find(item => item.isAssigned);
            if (assignedGroup) {
                classroom.groups = [];
                classroom.groups.push(assignedGroup);
            }

            return ({
                ...listObject,
                listItemId: classroom.id,
                elementId,
                groups: classroom.groups,
                name,
                info: {
                    additionalInfo,
                    badgeContent: classroom.yearGroupName,
                    badgeStyle: yearStyle
                },
                child: {
                    data: classroom.groups,
                    isMultiSelect: false
                },
                isExpandable: type === 'student'
            });
        });
    }

    return {
        assignData, unassignData
    };
};

export const getClassroomTeacherMapping = (teachers, classroomId, searchQuery = '', assignedIds = [],
    existingAssinedTeachers = [], loadOnce = true) => {
    let classroomTeacherMapping = [];
    for (const teacher of teachers) {
        if (teacher.assignedClassrooms.some(val => val.id === classroomId) && !loadOnce) {
            existingAssinedTeachers.push(teacher.userProfileId);
        }
        classroomTeacherMapping.push(
            {
                id: teacher.userProfileId,
                name: `${teacher.displayTitle} ${teacher.firstName} ${teacher.lastName}`,
                isAssigned: !loadOnce ?
                    teacher.assignedClassrooms.some(val => val.id === classroomId) :
                    assignedIds.indexOf(teacher.userProfileId) !== -1
            });
    }

    if (searchQuery !== '' || assignedIds.length > 0) {
        const unassignedList = classroomTeacherMapping.filter(
            (row =>
                row.name.toLowerCase().indexOf(searchQuery) !== -1 &&
                    !row.isAssigned
            )
        );

        const filteredTeachers = filter(classroomTeacherMapping, (val) => {
            if (assignedIds.indexOf(val.id) !== -1) {
                return true;
            }
            return false;
        });

        const assignedList = filteredTeachers.map((val) => {
            val.isAssigned = true;
            return val;
        });
        classroomTeacherMapping = [...new Set([...assignedList, ...unassignedList])];
    }

    return classroomTeacherMapping;
};

export const generateClassroomAssignList = (classroomTeacherMapping, listObject) => {
    const assignData = [];
    const unassignData = [];

    for (const teacher of classroomTeacherMapping) {
        if (teacher.isAssigned) {
            assignData.push({
                ...listObject,
                listItemId: teacher.id,
                elementId: `teacher-${teacher.id}-unassign`,
                name: truncateCharacters('assignTeacherToClassroom', teacher.name)
            });
        } else {
            unassignData.push({
                ...listObject,
                listItemId: teacher.id,
                elementId: `teacher-${teacher.id}-assign`,
                name: truncateCharacters('assignTeacherToClassroom', teacher.name)
            });
        }
    }

    return {
        assignData, unassignData
    };
};

export const assignClassroomFilter = (studentClassrooms = [], searchCriteria) => {
    let unassignedClassrooms = studentClassrooms.filter(val => !val.isAssigned);
    let assignedClassrooms = studentClassrooms.filter(val => val.isAssigned);
    const classrooms = filter(unassignedClassrooms, (classroom) => {
        const result = [];
        if (Number(classroom.yearGroup) === Number(searchCriteria.selectedYearGroup) ||
            Number(searchCriteria.selectedYearGroup) === -1) {
            result.push(classroom);
        }
        return result;
    });
    let searchResult = classrooms.concat(assignedClassrooms);

    // handle on search box
    if (searchCriteria.query !== '') {
        unassignedClassrooms = searchResult.filter(val => !val.isAssigned);
        assignedClassrooms = searchResult.filter(val => val.isAssigned);
        let filteredClassrooms = map(unassignedClassrooms, (item) => {
            let foundItem = false;
            const assignedTeachersName = [].concat(...item.assignedTeachersName);

            let searchItems = [item.name, ...assignedTeachersName];
            if (item.groups.length > 0) {
                const groups = map(item.groups, group => [group.name, group.courseName]);
                searchItems = [item.name, ...assignedTeachersName, ...([].concat(...groups))];
            }

            map(searchItems, (element) => {
                if (element.toLowerCase().indexOf(searchCriteria.query) !== -1) {
                    foundItem = true;
                }
                return false;
            });
            if (foundItem) return item;
            return false;
        });
        filteredClassrooms = filteredClassrooms.filter(Boolean);
        searchResult = filteredClassrooms.concat(assignedClassrooms);
    }

    return searchResult;
};

export function filterYearGroups(yearGroups) {
    const updatedYearGroups = yearGroups.map(item => ({
        key: item.yearGroupEnum.toString(),
        value: item.longName,
        selected: false,
        data: item
    }));

    return updatedYearGroups;
}


export const filterStudents = (students, filterCriteria, listObject, selectedClassroomId) => {
    let unassignStudents = [];
    let filteredData = students || [];
    let name = null;
    const additionalInfo = [];
    let elementId = null;
    let yearStyle = null;
    const yearGroup = parseInt(filterCriteria.yearGroup, 10);
    const classroomId = parseInt(filterCriteria.classroom, 10);
    if (students.length > 0) {
        if (filterCriteria.lastName !== '-1') {
            filteredData = filteredData.filter((item) => {
                if (startsWith(item.lastName.toLowerCase(), filterCriteria.lastName.toLowerCase())) {
                    return true;
                }
                return false;
            });
        }

        if (yearGroup !== -1) {
            filteredData = filteredData.filter((item) => {
                if (item.yearGroupEnum === yearGroup) {
                    return true;
                }
                return false;
            });
        }

        filteredData = filteredData.filter((item) => {
            if (item.assignedClassrooms.length === 0 && classroomId === -1) {
                return true;
            }
            const assignedClassIds = item.assignedClassrooms.map(classroom => classroom.classId);
            return includes(assignedClassIds, classroomId);
        });
    }

    if (filteredData.length > 0) {
        unassignStudents = filteredData.map((student) => {
            elementId = `student-${student.userProfileId}-unassign`;
            name = truncateCharacters('teacherClassroom', `${student.firstName} ${student.lastName}`);
            yearStyle = `yg${student.yearGroupEnum.toString()}`;
            const assignedClassIds = student.assignedClassrooms.map(classroom => classroom.classId);

            return ({
                ...listObject,
                listItemId: student.userProfileId,
                elementId,
                name,
                info: {
                    additionalInfo,
                    badgeContent: student.yearGroup,
                    badgeStyle: yearStyle
                },
                disabled: includes(assignedClassIds, selectedClassroomId)
            });
        });
    }

    return unassignStudents;
};

export const getAssignedStudentList = (students, listObject) => {
    let assignStudents = [];
    const additionalInfo = [];
    let elementId = null;
    let yearStyle = null;
    let name = '';

    if (students.length > 0) {
        assignStudents = students.map((student) => {
            elementId = `student-${student.userProfileId}-assign`;
            name = truncateCharacters('teacherClassroom', `${student.firstName} ${student.lastName}`);
            yearStyle = `yg${student.yearGroupEnum.toString()}`;

            return ({
                ...listObject,
                listItemId: student.userProfileId,
                elementId,
                name,
                info: {
                    additionalInfo,
                    badgeContent: student.yearGroup,
                    badgeStyle: yearStyle,
                    selected: student.selected
                }
            });
        });
    }
    return assignStudents;
};

export const filterClassroomByIds = (classrooms, classroomIds) => {
    const filterdClassooms = classrooms.filter((classroom) => {
        if (classroomIds.includes(classroom.classroomId)) {
            return true;
        }

        return false;
    });
    return filterdClassooms;
};

export const refreshLicenseCount = (students, unassignedStudentIds) => {
    const unassignedStudents = filter(students, (val) => {
        if (unassignedStudentIds.indexOf(val.userProfileId) !== -1) {
            return true;
        }
        return false;
    });

    for (const student of unassignedStudents) {
        if (student.assignedClassrooms.length === 1) {
            return true;
        }
    }

    return false;
};

export const nonEmptyClassroom = classroom => classroom.studentsCount > 0;

export const customDefaultCourses = (courses) => {
    if (courses) {
        return courses.map(item => ({
            courseId: item.courseId,
            courseName: item.courseName,
            yearGroupId: item.yearGroupEnum,
            yearGroupName: item.yearGroupShortName,
            newCourseId: 0,
            newCourseName: '',
            isSelected: false
        }));
    }
    return {};
};

export const validateStudentDeletion = (payload) => {
    const noOfStudents = payload.length;
    const result = {
        isPartialDelete: false,
        noOfStudentsDeleted: 0
    };

    // number of students deleted without any error
    const deletedStudents = payload.filter(val => !val.hasError).length;

    if (deletedStudents > 0) {
        // check if some of the students were deleted
        result.isPartialDelete = noOfStudents !== deletedStudents;

        result.noOfStudentsDeleted = ((noOfStudents - deletedStudents) === 0 ?
            deletedStudents : (noOfStudents - deletedStudents));
    }
    return result;
};

export const getJWTToken = () => {
    const { jwt } = queryString.parse(location.search);
    return jwt === undefined ? '' : `Bearer ${jwt}`;
};

export const PARTIAL_ROLLOVER = 'PartialRollover';

export const displayNewCourses = () => {
    const config = getAppConfig();

    if (!config) return false;

    const queryParams = queryString.parse(location.search);
    const countryCode = queryParams.countryCode || '';
    let newCoursesVisibilityCriteria = {};
    if (config.newCoursesVisibilityCriteria) {
        newCoursesVisibilityCriteria = config.newCoursesVisibilityCriteria;
    }

    const countryCodes = newCoursesVisibilityCriteria.countryCodes || [];
    return countryCodes.includes((countryCode));
};

const getUserCountryCode = () => {
    const { countryCode } = queryString.parse(location.search);
    return countryCode ? countryCode.toUpperCase() : '';
};

/**
 * Determines if the 'New Courses' courses are available for the selected Year (Grade) and Country
 * Part of COY-9034 to limit to Australian schools years 3-6 at the time of initial release.
 * @returns {boolean}
 */
export const newCoursesAvailable = (yearGroup = '', countryId = '') => {
    const config = getAppConfig();
    const userCountryCode = countryId || getUserCountryCode();

    if (!config || Object.keys(config).length === 0 || !config.newCoursesAvailability) return false;

    const { yearGroups = [] } = config.newCoursesAvailability[userCountryCode] || {};
    return yearGroups.includes(parseInt(yearGroup, 10));
};

export const getNewCoursesTitle = (yearGroup, isNewCourseAssigned, conquestCourseTitle, intl) => {
    if (isNewCourseAssigned) return conquestCourseTitle;

    const config = getAppConfig();
    const userCountryCode = getUserCountryCode();
    const availabilityMap = config && config.newCoursesAvailabilityForStudents;
    const availability = availabilityMap && availabilityMap[userCountryCode];
    const isAvailable = availability && Array.isArray(availability.yearGroups) && availability.yearGroups.includes(parseInt(yearGroup, 10));

    return intl.formatMessage(isAvailable ? messages.noCourseAssigned : messages.noCoursesFound);
};

export const showDefaultCourseAtTop = (courseList, useAdminSelection) => {
    if (courseList.length > 0) {
        const defaultCourse = [
            {
                id: 0,
                key: 0,
                name: useAdminSelection
            },
            ...courseList
        ];

        const defaultCourseIndex = defaultCourse.findIndex(course => course.isDefault);

        if (defaultCourseIndex !== -1) {
            const defaultCourseAtTop = defaultCourse.splice(defaultCourseIndex, 1);
            defaultCourse.splice(1, 0, defaultCourseAtTop[0]);
        }

        return defaultCourse;
    }

    return courseList;
};

export const moveFlaggedToFront = (arr, prop) => {
    const index = arr.findIndex(item => item && typeof item === 'object' && item[prop] === true);

    if (index > 0) {
        const flaggedItem = arr.splice(index, 1)[0];
        arr.unshift(flaggedItem);
    }

    return arr;
};



// WEBPACK FOOTER //
// ./app/helpers/utils.js